// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1rOL6","file":"styles_file__1lP6d"};